import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import networkNameReducer from '../modules/providerSearch/api/networkName';
import cityListReducer from '../modules/providerSearch/api/cityList';
import providerSearchReducer from '../modules/providerSearch/api/providerSearch';
import providerSearchDataReducer from '../modules/providerSearch/api/providerSearchData';
import providerSpeciality from '../modules/providerList/api/speciality';
import radiusListReducer from '../modules/providerSearch/api/radiusList';
import facilitySliceReducer from '../modules/providerList/api/facility';
import networkRefSliceReducer from '../modules/providerSearch/api/networkRefData';
import branchesSliceReducer from '../modules/providerList/api/getBranches';
import getProviderSliceReducer from '../modules/providerList/api/getProvider';
import getStateSliceReducer from '../modules/providerSearch/api/getState';
import getSpecialtyTypeSliceReducer from '../modules/providerSearch/api/getSpecialtyType';
import getFacilityTypeSliceReducer from '../modules/providerSearch/api/getFacilityType';

export const rootReducer = (history) => combineReducers({
    router: connectRouter(history),
    branchList: branchesSliceReducer,
    cityList: cityListReducer,
    facility: facilitySliceReducer,
    facilityType: getFacilityTypeSliceReducer,
    providerDetails: getProviderSliceReducer,
    networkDropDown: networkNameReducer,
    providerDescription: networkRefSliceReducer,
    providerSearchCriteria: providerSearchDataReducer,
    providerSearch: providerSearchReducer,
    speciality: providerSpeciality,
    specialtyType: getSpecialtyTypeSliceReducer,
    statesList: getStateSliceReducer,
    radiusList: radiusListReducer
});

export default rootReducer;
